export const AADSTS_CODE_FALLBACK_REGEX = /^AADSTS(\d+):\s+(.+)$/;
